$(document).ready(function(){  
  // Product Accordian
  $('.accordian__heading').click(function(e) {
    let $this = $(this);  
    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.removeClass('active-accordian');
      $this.next().slideUp(350);
    } else {
      $('.accordian__heading').removeClass('active-accordian');
      $this.parent().parent().find('.product__accordian-wrapper .product__desc-wrapper').removeClass('show');
      $this.parent().parent().find('.product__accordian-wrapper .product__desc-wrapper').slideUp(350);
      $this.toggleClass('active-accordian');
      $this.next().toggleClass('show');
      $this.next().slideToggle(350);
    }
  });
  
  if($(window).width() < 992){
    $('.categories-collapse .collapse_block').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      autoplay: false,
      centerMode: false,
      centerPadding: '60px',
      responsive: [
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: true,
            centerPadding: '60px'
          }
        }
      ]
    });
  }
  $('.heading_list').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    cssEase: 'linear'
  });
  $('.collection_slider').slick({
      dots: false,
      arrows: true,
      speed: 500,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

setTimeout(function() {
  if($('.collection-tab #recently-viewed-products .product').length > 3){
    $('.collection-tab #recently-viewed-products').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3              
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
    });
  }
},2000);
  // $('.drawer-product-grid-new').slick({
  //     dots: false,
  //     arrows: true,
  //     infinite: true,
  //     centerMode: true,
  //     centerPadding: '60px',
  //     speed: 300,
  //     slidesToShow: 3,
  //     slidesToScroll: 3
  //   });
  $('.drawer-product-grid-new').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4              
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '60px'
          }
        }
      ]
    });
 
  $(document).on('click','.boost-sd__btn-quick-view',function(){
     $('body').addClass('quickview');
  });
  $(document).on('click','.boost-sd__button-text-x--as-close-modal',function(){
     $('body').removeClass('quickview');
  });
  $(document).on('click','.boost-sd__modal-backdrop',function(){
     $('body').removeClass('quickview');
  });
  $(document).on('click','.filter',function(){
    if($(this).hasClass('active')){
      $(this).removeClass('active');
    }else{
      $(this).addClass('active');
    }
  }); 
  if($(window).width() < 989){
    $(document).on('click','.footer-block__heading',function(){
      if($(this).parent().hasClass('active')){
       $(this).parent().removeClass('active'); 
      }else{
        $(this).parent().addClass('active'); 
      }
    });
  }

  $(document).on('click','.product_details_list ul li',function(){
    var product_tab_id = $(this).data('id');
    $('.main_popup_div').find('#'+product_tab_id).addClass('show');
    $('body').addClass('pro_overlay');
  });
  
  $(document).on('click','.main_popup_div .close',function(){
    var product_desc_id = $(this).parent().attr('id');
    $('.main_popup_div').find('#'+product_desc_id).removeClass('show');
    $('body').removeClass('pro_overlay');
  });
$(".tab-container .tab_content").hide();
$('#tab1').show();
  $("ul.tabs li").click(function() {
    if($('#recently-viewed-products .product').length > 3){
     setTimeout(function() { $('#recently-viewed-products').slick('refresh'); },1000);
    }
    $('.tab_container .chosen_for_you').slick('refresh');
    var parent = $(this).parents('.tab-container');
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  
  });
});

// Menu Hover

let items = document.querySelectorAll(".mega-menu");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      console.log(item.querySelector(".list-menu--inline"));
      document.querySelector("ul.list-menu--inline").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  }); 
});


// Account Js
$(document).ready(function(){
  $('.subscription-links .tab-link').on('click', function(){
    var tab = $(this).data('tab');
    $('.subscription-links .tab-link').removeClass('active');
    $(this).addClass('active');
    
    $('.subscription-tab-container .tab-content').removeClass('active');
    $('.subscription-tab-container .tab-content#'+tab).addClass('active');
    //$("html").animate({ scrollTop: 0 }, "slow");
  });
  
  var hash = window.location.hash;
  console.log(hash);
  if(hash != ''){
    $('.account-sidebar li').removeClass('active');
    $('[data-tab="'+hash+'"]').parent('li').addClass('active');
    
    $('.account-tabs .account-tab').removeClass('active');
    $(hash).addClass('active');
  }
  
  $('.account-sidebar a.account-links').on('click', function(e){
    e.preventDefault();
    var hash = $(this).data('tab');
   	
    console.log(hash);    
    
    if(hash != undefined){
      var url = window.location.href;
      console.log(url);
      console.log(url.indexOf('#'));
      if(url.indexOf('#') != -1){
        var arr = url.split('#');
        window.location.href = arr[0]+hash;
      }else{
        window.location.href = url+hash;
      }
      
      $('.account-sidebar li').removeClass('active');
      $('[data-tab="'+hash+'"]').parent('li').addClass('active');

      $('.account-tabs .account-tab').removeClass('active');
      $(hash).addClass('active');
      $("html").animate({  scrollTop: $(".account-tab").offset().top
    }, 2000);
    }else{
      var url = window.location.href;
      window.location.href = url.replace(window.location.hash, '');
      
      $('.account-sidebar li').removeClass('active');
      $('.account-sidebar-nav li:first').addClass('active');

      $('.account-tabs .account-tab').removeClass('active');
      $('.account-tabs .account-tab:first').addClass('active');
      $("html").animate({  scrollTop: $(".account-tab").offset().top
    }, 2000);
    }
  });
  $(document).on('click','.address_edit_btn',function(){
    var form_id = $(this).attr('aria-controls');
    if($('.adress_form_block .edit_address').hasClass('active')){
     $('.adress_form_block .edit_address').removeClass('active'); 
    }else{
     $('.adress_form_block #'+form_id).addClass('active');
     $('.adress_form_block #AddAddress').removeClass('active'); 
    }
  });
  $(document).on('click','.add_address_box',function(){
    if($('.adress_form_block #AddAddress').hasClass('active')){
     $('.adress_form_block #AddAddress').removeClass('active'); 
    }else{
     $('.adress_form_block #AddAddress').addClass('active'); 
     $('.adress_form_block .edit_address').removeClass('active'); 
    }
  });

  $(document).on('click','.odr_main_status .link',function(e){
    e.preventDefault();
    if($(this).parent().find('.status_result').hasClass('active')){
      $(this).parent().find('.status_result').removeClass('active');
    }else{
      $(this).parent().find('.status_result').addClass('active');
    }
  });
  $(document).on('click','.swatch_button .option_image_click',function(){
    var product_handle = $(this).data('handle');
    var variant_title = $(this).val();
    jQuery.getJSON('/products/'+ product_handle +'.js', function(product) {
      $( product.variants ).each(function( index, value ) {
          if(value.featured_image != ''){
            var variant_title_loop = value.title;
            if(variant_title_loop.includes(variant_title)){
              var variant_image = value.featured_image.src;
              $('.card__media img.'+product_handle).attr('srcset',variant_image);
              return false;
            }
          }
      });
    });
  });
setTimeout(function() {

$('.product_option .swatch_button').hide();
$('.product_option').find('.swatch_button:lt(4)').show();

// $('.ShowMore').click(function(ev) {
//   $(ev.currentTarget).parent().find('.swatch_button').show();
// });
},500);
//  $("body").click(function(event){
//     if(
//       document.getElementById("product_details").contains(event.target)
//       || document.getElementById("product_shipping").contains(event.target)
//       || document.getElementById("customer_service").contains(event.target)
//       || document.getElementById("product_details1").contains(event.target)
//       || document.getElementById("product_shipping1").contains(event.target)
//       || document.getElementById("customer_service1").contains(event.target)
//     ){
//         // Event triggered from within the #menutop div element
//         // Do nothing and return
//         return;
//     }
//     // We are here because click event triggered from outside of #menutop div element
//    $('.main_popup_div .close').trigger('click');
// });
$(document).on('click','.drawer-you-may-like .quick-add__submit',function(e){
  console.log('hi');
  e.preventDefault();
  var pro_id = $(this).parent().find('input[name="id"]').val();
  console.log(pro_id);
  let formData = {
   'items': [{
    'id': pro_id,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    $.getJSON('/cart.json').then(cart => {
        fetch(routes.cart_url + '?view=item').then(response => response.text())
          .then(text => {
              const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
           
              const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;
              const totalPrice = sectionInnerHTML.querySelector('#CartDrawer .totals__subtotal-value').innerHTML;
              $('#CartDrawer').html(cartFormInnerHTML)
              $('cart-drawer').removeClass('is-empty')
              $('cart-drawer-items').removeClass('is-empty')
              if ($('#cart-icon-bubble .cart-count-bubble').length === 0) {
                  const cartNumber = document.createElement('div')
                  cartNumber.className = 'cart-count-bubble'
                  cartNumber.innerHTML = `
              <span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">${cart.item_count} items</span>
              `
                  $('#cart-icon-bubble').append(cartNumber)
              } else {
                  $('.cart-count-bubble span[aria-hidden="true"]').each((_, count) => $(count).text(cart.item_count))
              }
          })
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  
});
  $(document).on('click','.main_set_item_remove',function(e){
    e.preventDefault();
    var variant_ids = [];
    var pro_handle = $(this).data('handle');
    var main_pro_id = $(this).data('id');
    variant_ids.push(main_pro_id);
    $('.set_sub_product').each(function(){
      var variant_id = $(this).find('.right_cart cart-remove-button button').data('id');
      variant_ids.push(variant_id);
    });
    var qty = 0;
    var data = { updates: {} };
   
    for (i = 0; i < variant_ids.length; i++) {
       data.updates[variant_ids[i]] = qty;
    }
    jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(data) {
      console.log(data["item_count"]);
      if(data["item_count"] > 0){
        $.getJSON('/cart.json').then(cart => {
            fetch(routes.cart_url + '?view=item').then(response => response.text())
                .then(text => {
                    const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                 
                    const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;
                    const totalPrice = sectionInnerHTML.querySelector('#CartDrawer .totals__subtotal-value').innerHTML;
                    $('#CartDrawer').html(cartFormInnerHTML)
                    $('cart-drawer').removeClass('is-empty')
                    $('cart-drawer-items').removeClass('is-empty')
                    if ($('#cart-icon-bubble .cart-count-bubble').length === 0) {
                        const cartNumber = document.createElement('div')
                        cartNumber.className = 'cart-count-bubble'
                        cartNumber.innerHTML = `
                    <span aria-hidden="true"></span>
                    <span class="visually-hidden"> 0 items</span>
                    `
                        $('#cart-icon-bubble').append(cartNumber)
                    } else {
                        $('.cart-count-bubble span[aria-hidden="true"]').each((_, count) => $(count).text(cart.item_count))
                    }
                    //$('#cart-icon-bubble')[0].click()
                   // if(window.Rebuy){  Rebuy.init(); }
                   //  $('#CartDrawer-Overlay').on('click', () => {
                   //      $('cart-drawer').removeClass('active')
                   //      $('body').removeClass('overflow-hidden')
                   //  })
                })
        });
      }else{
        $('#CartDrawer-Overlay').remove();
        $('.drawer__inner').remove();
        var close = "this.closest('cart-drawer').close()";
        $('#CartDrawer').append('<div id="CartDrawer-Overlay" class="cart-drawer__overlay"></div><div class="drawer__inner" role="dialog" aria-modal="true" aria-label="Your cart" tabindex="-1"><div class="drawer__inner-empty"><div class="drawer__header"><span class="cart_bag"><svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.6757 15.3161V5.64697C25.6757 2.88555 23.4371 0.646973 20.6757 0.646973H7.31836C4.55694 0.646973 2.31836 2.88555 2.31836 5.64697V15.3161" stroke="#343031" stroke-width="1.2" stroke-linecap="round"></path><path d="M0.761719 18.6323C0.761719 18.08 1.20943 17.6323 1.76172 17.6323H26.2334C26.7857 17.6323 27.2334 18.08 27.2334 18.6323V20.3529C27.2334 23.1143 24.9948 25.3529 22.2334 25.3529H5.76172C3.00029 25.3529 0.761719 23.1143 0.761719 20.3529V18.6323Z" stroke="#343031" stroke-width="1.2" stroke-linejoin="round"></path><path d="M22.1724 17.6325C22.1724 13.1553 18.5123 9.52588 13.9973 9.52588C9.48237 9.52588 5.82227 13.1553 5.82227 17.6325" stroke="#343031" stroke-width="1.2" stroke-linejoin="round"></path><path d="M18.6691 17.6324C18.6691 15.074 16.5776 13 13.9976 13C11.4177 13 9.32617 15.074 9.32617 17.6324" stroke="#343031" stroke-width="1.2" stroke-linejoin="round"></path><path d="M15.9448 4.12134H12.0519L10.1055 6.18016L13.2684 9.52575H14.7283L17.8913 6.18016L15.9448 4.12134Z" stroke="#343031" stroke-width="1.2" stroke-linejoin="round"></path></svg></span><h2 class="drawer__heading">Your Cart</h2><button class="drawer__close" type="button" onclick="'+ close +'" aria-label="Close"><svg class="icon icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 15L1 1" stroke="#343031" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1 15L15 1" stroke="#343031" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div><div class="cart-drawer__warnings center cart-drawer__warnings--has-collection"><div class="cart-drawer__empty-content"><h2 class="cart__empty-text">Your cart is empty</h2><a href="/collections/all" class="button">Continue shopping</a><p class="cart__login-title h3">Have an account?</p><p class="cart__login-paragraph"><a href="/account/login" class="link underlined-link">Log in</a> to check out faster.</p></div></div></div></div>');
        $('cart-drawer').addClass('is-empty');
        $('.cart-count-bubble').remove();
      }
      
    }
  });
  });

  /**
 * touchHover.js
 *
 * Create tooltips on mouseover or on click (for supporting touch interfaces).
 * 
 * @author C. Scott Asbach
 */

	$('.varient-btn').each(function(){		
		
		$(this).data('title',$(this).attr('title'));
  
		$(this).removeAttr('title');
	
	});


	$('.varient-btn').mouseover(function() {		

		$('.varient-btn').next('.tooltip').remove();
		

		$(this).after('<span class="tooltip">' + $(this).data('title') + '</span>');
		
	
		var top = $(this).position().top + $(this).width() + 4;
		
		$(this).next().css('top',top);				
		
	});
	

	$('.varient-btn').click(function(){
		
		$(this).mouseover();
		
		// after a slight 2 second fade, fade out the tooltip for 1 second
		$(this).next().animate({opacity: 0.9},{duration: 2000, complete: function(){
			$(this).fadeOut(1000);
		}});
		
	});
	
	$('.varient-btn').mouseout(function(){	
		$(this).next('.tooltip').remove();				

	});

});

$('.block__prd-custom-variant-stone-text-box input').on('keyup', function(e){
  $('#number_of_stones').val(e.target.value); 
});

// name-necklace input field added
$('#block__prd-custom-input').on('keyup', function(e) {
  if (e.currentTarget.dataset.text == 'alpha') {
    e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '');
  }
  
  // let formattedText = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1).toUpperCase();
  // $('#personalized_text_input').val(formattedText);
  const value = e.target.value;

  if (value.length > 0) {
    const formattedText = value
      .split(' ')
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ');

    e.target.value = formattedText;
    $('#personalized_text_input').val(formattedText);
  }
  $('.error_message').hide();

  // if(!document.getElementById('block__prd-custom-input').value == ''){
  //   document.getElementById('block__prd-custom-input').style.textTransform = "capitalize";
  // }else{
  //   document.getElementById('block__prd-custom-input').style.textTransform = "capitalize";
  // }
});
$('.product-form-atc-custom').click(function(e){
  if($('#block__prd-custom-input').val() == ''){
      e.preventDefault();
     $('.error_message').show();
   }else{
    $('.error_message').hide();
   }
});